import { useState } from 'react';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';

import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

import { Button } from 'react-bootstrap';
import { Close } from './icons';



export default function PDFViewer({ url }: any) {
    const [show, setShow] = useState(false);
    const defaultLayoutPluginInstance = defaultLayoutPlugin();

    return <>
        <Button disabled={!url} onClick={() => setShow(!show)} variant='info' className="button-shared-style view-button" >
            View
        </Button>
        {show ?
            <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.0.279/build/pdf.worker.js">
                <div className="backdrop" >
                    <div className="pdf-viewer"  >
                        <span className="clickable" onClick={() => setShow(!show)} ><Close color={"white"} size={"3x"} /></span>
                        <Viewer
                            fileUrl={url}
                            plugins={[
                                defaultLayoutPluginInstance,
                            ]}
                        />
                    </div>
                </div >
            </Worker > : null}
    </>


}